import { useGetCampaign } from "../../providers/Campaign.provider";

export function useCampaignHooks() {

  const campaign = useGetCampaign({ statuses: ['ACTIVE', 'PENDING'] });

  return {
    campaign
  };
}
